import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);





function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/login');
  }
}










  const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/login.vue'),
    beforeEnter: loggedInRedirectDashboard,
  },



  {
    path: '/',
    name: 'Home',
    // component: Home,
    component: () => import('../views/usulan/usulan.vue'),
    beforeEnter: isLoggedIn,
  },


  {
    path: '/usulan',
    name: 'usulan',
    component: () => import('../views/usulan/usulan.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/verifikasi',
    name: 'verifikasi',
    component: () => import('../views/verifikasi/verifikasi.vue'),
    beforeEnter: isLoggedIn,
  },


 
  {
    path: '/menuList',
    name: 'menuList',
    component: () => import('../views/dataMaster/menuList.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/klpUsers',
    name: 'klpUsers',
    component: () => import('../views/dataMaster/klpUsers.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/registrasi',
    name: 'registrasi',
    component: () => import('../views/dataMaster/registrasi.vue'),
    beforeEnter: isLoggedIn,
  },
  
  {
    path: '/masterKategori',
    name: 'masterKategori',
    component: () => import('../views/dataMaster/masterKategori.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/masterKategoriFile',
    name: 'masterKategoriFile',
    component: () => import('../views/dataMaster/masterKategoriFile.vue'),
    beforeEnter: isLoggedIn,
  },
  

  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    beforeEnter: isLoggedIn,
  },


]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
